import { render, staticRenderFns } from "./U3Search.vue?vue&type=template&id=fdbc15f0&"
import script from "./U3Search.js?vue&type=script&lang=js&"
export * from "./U3Search.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/frameto/WebSites/U3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fdbc15f0', component.options)
    } else {
      api.reload('fdbc15f0', component.options)
    }
    module.hot.accept("./U3Search.vue?vue&type=template&id=fdbc15f0&", function () {
      api.rerender('fdbc15f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/U3Search.vue"
export default component.exports